module.exports = __webpack_public_path__ + "img/home_stretches_video4.c8220260.c8220260.png";